// extracted by mini-css-extract-plugin
export default {"box":"RatingRequest_box__3it0H","text":"RatingRequest_text__YGpn6","starList":"RatingRequest_starList__LPv-A","star":"RatingRequest_star__k1odM"};